export default __webpack_public_path__ + "static/media/brandGuidelinesImagePage33.cbbdfccd.png";